import { useMemo } from 'react';
import useSWR from 'swr';
import { getNestedDataFetcher } from '@/utils/apis';

type BrandRow = { brandCode: string; brandName: string };

/**
 * 품의 브랜드 드롭다운 — 기본 프로필 ERP 계정의 브랜드 권한(레거시 combo_brand 와 같은 목록, BRAND.SORT 순).
 * businessType 을 주면 BRAND.TYPE_BIZ 로 거름
 */
const useMyBrandOptions = (businessType?: string) => {
  const url = businessType
    ? `/api/v1/passport/me/brands?businessType=${encodeURIComponent(
        businessType,
      )}`
    : '/api/v1/passport/me/brands';
  const { data, error, isLoading } = useSWR<BrandRow[]>(
    url,
    getNestedDataFetcher,
    { revalidateOnFocus: false },
  );
  const options = useMemo(
    () =>
      (data ?? [])
        .filter((row) => row.brandCode)
        .map((row) => ({ value: row.brandCode, label: row.brandName })),
    [data],
  );
  return { options, error, isLoading };
};

export default useMyBrandOptions;
